package com.dotdrives.repository

import com.dotdrives.client.AutomationRuleClient
import com.dotdrives.model.AutomationRule
import com.dotdrives.model.NewAutomationRule
import com.dotdrives.model.RulePreviewCount

interface AutomationRuleRepository {
    suspend fun list(orgId: String): Result<List<AutomationRule>>

    suspend fun setEnabled(orgId: String, ruleId: String, enabled: Boolean): Result<Unit>

    suspend fun create(orgId: String, rule: NewAutomationRule): Result<AutomationRule>

    /**
     * Dry-run: how many times this trigger/condition combination would have fired in the
     * last 30 days, computed from `activity_events` (docs/schema.md). Only meaningful for a
     * verb-dispatched draft -- a null `triggerVerb` (cron-scanned condition rule) has no
     * event to count and callers should not invoke this for one. `complete = false` in the
     * result means the count could not be fully verified (RLS hid some matching rows), not
     * that it is a confident answer.
     */
    suspend fun previewFireCount(orgId: String, triggerVerb: String, minAmountCents: Long?): Result<RulePreviewCount>
}

class SupabaseAutomationRuleRepository(
    private val client: AutomationRuleClient = AutomationRuleClient(),
) : AutomationRuleRepository {
    override suspend fun list(orgId: String): Result<List<AutomationRule>> =
        runCatching { client.list(orgId) }

    override suspend fun setEnabled(orgId: String, ruleId: String, enabled: Boolean): Result<Unit> =
        runCatching { client.setEnabled(orgId, ruleId, enabled) }

    override suspend fun create(orgId: String, rule: NewAutomationRule): Result<AutomationRule> =
        runCatching { client.create(orgId, rule) }

    override suspend fun previewFireCount(
        orgId: String,
        triggerVerb: String,
        minAmountCents: Long?,
    ): Result<RulePreviewCount> =
        runCatching { client.previewFireCount(orgId, triggerVerb, minAmountCents) }
}
